import * as yup from 'yup';
import { FavoriteIposFormField } from './FavoriteIposFormField';

export const validationSchema = yup.object().shape({
  [FavoriteIposFormField.Ticker]: yup.string(),
});
